/* An affordance to return to the native form, never a second add-to-cart flow. */
if (!customElements.get('vexon-product-details')) {
  customElements.define('vexon-product-details', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;
      this.titleElement = this.querySelector('[data-vx-variant-title]');
      this.jump = this.querySelector('[data-vx-purchase-jump]');
      this.form = this.productInfo.querySelector('product-form form[data-type="add-to-cart-form"]');
      this.submit = this.form?.querySelector('[name="add"]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.formVisible = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.productInfo.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) this.readNativeVariant();
      }, options);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) === this.dataset.sectionId) this.updateVariant(data.variant);
        });
      }
      if (!this.jump || !this.form || !this.submit || !('IntersectionObserver' in window)) return;
      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.formVisible = entries.some((entry) => entry.isIntersecting);
        this.updateJump();
      }, { rootMargin: '-80px 0px 0px', threshold: 0 });
      this.intersectionObserver.observe(this.submit);
      this.mutationObserver = new MutationObserver(() => this.updateJump());
      this.mutationObserver.observe(this.submit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.mobile.addEventListener('change', () => this.updateJump(), options);
      this.reduceMotion.addEventListener('change', () => this.updateJump(), options);
      this.jump.addEventListener('click', () => {
        const target = this.productInfo.querySelector('variant-selects') || this.form;
        target.scrollIntoView({ behavior: this.reduceMotion.matches ? 'instant' : 'smooth', block: 'center' });
        const focusTarget = target.querySelector('select, input:not([type="hidden"]):not(:disabled), button:not(:disabled)') || this.submit;
        focusTarget.focus({ preventScroll: true });
      }, options);
    }

    readNativeVariant() {
      const id = this.form?.querySelector('input[name="id"]')?.value;
      if (!id) {
        this.updateVariant(null);
        return;
      }
      const state = this.productInfo.querySelector('variant-selects [data-selected-variant]');
      if (!state) return;
      try {
        const variant = JSON.parse(state.textContent);
        if (String(variant?.id) === id) this.updateVariant(variant);
      } catch {
        // Native form and its translated error handling continue to work independently.
      }
    }

    updateVariant(variant) {
      if (this.titleElement) this.titleElement.textContent = variant?.title || 'Bu seçenek birleşimi mevcut değil.';
      this.updateJump();
    }

    updateJump() {
      if (!this.jump) return;
      this.jump.hidden = !this.mobile.matches || this.reduceMotion.matches || this.formVisible ||
        !this.submit || this.submit.disabled || this.submit.getAttribute('aria-disabled') === 'true';
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.unsubscribe?.();
      this.intersectionObserver?.disconnect();
      this.mutationObserver?.disconnect();
    }
  });
}
